var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 34 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.5 4C6.701 4 2 8.701 2 14.5c0 4.825 3.255 8.892 7.69 10.12.468.13.823.533.876 1.032l.584 5.546 6.838-5.906a1.2 1.2 0 0 1 .785-.292H21.5C27.299 25 32 20.299 32 14.5S27.299 4 21.5 4zM0 14.5C0 7.596 5.596 2 12.5 2h9C28.404 2 34 7.596 34 14.5S28.404 27 21.5 27h-2.43L11.3 33.712a1.2 1.2 0 0 1-1.978-.783l-.688-6.54C3.623 24.762 0 20.056 0 14.5",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17 8.5a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4h-4a1 1 0 1 1 0-2h4v-4a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})));
export default SvgIconComment;